require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./shwetajalanofadventinternational.json") })
        }
      }, "path---shwetajalanofadventinternational");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---shwetajalanofadventinternational!./.cache/json/shwetajalanofadventinternational.json
// module id = 1245
// module chunks = 231608221292675